// extracted by mini-css-extract-plugin
export default {"loaderContainer":"COBarChart_loaderContainer__pXEGt","labels":"COBarChart_labels__hQ4Xw","xAxisLabel":"COBarChart_xAxisLabel__1fs6t"};